import { useStore as s } from "@nanostores/react";
import { useState as l, useCallback as a, useEffect as f } from "react";
import { atom as m } from "nanostores";
import { CopilotSession as n } from "../session.js";
import { currentCopilotSession as r } from "../global-state.js";
const c = m(null);
function g(t) {
  const [o, i] = l(() => new n()), u = a(() => {
    const e = new n();
    return i(e), e;
  }, []);
  return f(() => {
    t?.isPrimary && r.set(o);
  }, [o, t?.isPrimary]), o.reset == null && Object.assign(o, { reset: u }), o;
}
function w() {
  return s(r);
}
function y(t) {
  return s(t?.__status ?? c);
}
function M(t) {
  return s(t.__statefulMessages);
}
function P(t) {
  return s(t.__tools);
}
function j(t) {
  return s(t.__meta);
}
export {
  P as useCopilotAvailableTools,
  M as useCopilotMessages,
  j as useCopilotMeta,
  g as useCopilotSession,
  y as useCopilotStatus,
  w as usePrimaryCopilotSession
};
